import { coletarEstadosFormulas } from '@shared/components/formula/utils/formula-estados.util';
import { Component, Input, inject } from '@angular/core';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MaskService } from '@shared/services/mask.service';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AtivacaoSectionCardComponent } from '@shared/components/ativacao-section-card/ativacao-section-card.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { FormulaEditorDialogComponent, FormulaEditorDialogData, FormulaEditorDialogResult } from '@shared/components/formula/formula-editor-dialog/formula-editor-dialog.component';
import { AliquotaCbsDialogComponent } from '../../../../dialogs/aliquota-cbs-dialog/aliquota-cbs-dialog.component';
import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';
import { TipoFormulaEnum } from '@shared/enums/formula/tipo-formula.enum';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaCatalogoService } from '@shared/services/apis/motor-fiscal/formula-catalogo.service';

/** Seção CBS da aba IBS/CBS: redução, diferimento e devolução de tributo. */
@Component({
    selector: 'app-regra-tributaria-cbs-section',
    standalone: true,
    imports: [
        NgxCurrencyDirective,
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        AtivacaoSectionCardComponent,
        MatIconModule,
        MatButtonModule,
        MatBadgeModule,
        MatTooltipModule,
    ],
    templateUrl: './regra-tributaria-cbs-section.component.html',
    styleUrl: './regra-tributaria-cbs-section.component.css',
})
export class RegraTributariaCbsSectionComponent {
    @Input({ required: true }) form!: FormGroup;

    public readonly percentMask = inject(MaskService).getPercentMask();
    @Input() formulas: FormulaCatalogoItemStruct[] = [];
    @Input() cashbackHabilitado = true;
    @Input() cashbackTooltip = '';

    public get estadosControl(): FormControl {
        return this.form.get('_estadosFormulas') as FormControl;
    }

    constructor(
        private dialog: MatDialog,
        private formulaCatalogoService: FormulaCatalogoService,
    ) {}

    public get personalizadasCount(): number {
        const estados = (this.estadosControl?.value as FormulaItemStruct[]) ?? [];
        return estados.filter(e => e.tipo === TipoFormulaEnum.Personalizada).length;
    }

    public abrirEditorFormulas(): void {
        const data: FormulaEditorDialogData = {
            titulo: 'CBS',
            formulas: this.formulas,
            estadosIniciais: (this.estadosControl?.value as FormulaItemStruct[]) ?? [],
            estadosFormulasAgregados: coletarEstadosFormulas(this.form),
            contextoRaiz: 'regra-tributaria',
            validarPersonalizacoes: request => this.formulaCatalogoService.validarPersonalizacoes(request),
        };
        const ref = this.dialog.open(FormulaEditorDialogComponent, { width: '900px', maxWidth: '96vw', maxHeight: '92vh', data });
        ref.afterClosed().subscribe((result: FormulaEditorDialogResult | null) => {
            if (result) {
                this.estadosControl.setValue(result.formulas);
            }
        });
    }

    public abrirTabelaAliquota(): void {
        this.dialog.open(AliquotaCbsDialogComponent, { width: '760px', maxWidth: '96vw', maxHeight: '90vh' });
    }

    public get reducaoControl(): FormControl {
        return this.form.get('reducaoAtivo') as FormControl;
    }

    public get diferimentoControl(): FormControl {
        return this.form.get('diferimentoAtivo') as FormControl;
    }

    public get devolucaoControl(): FormControl {
        return this.form.get('devolucaoAtivo') as FormControl;
    }
}
